import React from 'react';
import PropTypes from 'prop-types';

import {InputLabel, FormControl, Select} from '@mui/material';
import {Menu, MenuItem, IconButton} from '@mui/material';

const Dropdown = (props) => {
  const {label, value, onChange, children, disabled, required, id, variant = 'outlined', ...otherProps} = props;
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl variant={variant} fullWidth >
      <InputLabel required={required}>
        {label}
      </InputLabel>
      <Select
        onChange={handleChange}
        value={value}
        style={{'textAlign': 'left'}}
        disabled={disabled}
        label={label}
        data-id={id}
        MenuProps={{disablePortal: true}}
        {...otherProps}
      >
        {children}
      </Select>
    </FormControl>
  );
};
Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  id: PropTypes.string,
  variant: PropTypes.string,
};

const DropdownIcon = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const disabled = Boolean(props.disabled);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const childrenWithProps = React.Children.map(props.children, (child) => {
    // Checking isValidElement is the safe way and avoids a typescript  error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {onClick: () => (child?.props?.onClick && child.props.onClick()) | handleClose()});
    }
    return child;
  });
  return (
    <React.Fragment>
      <IconButton onClick={handleClick} disabled={disabled} size="large" >
        {props.icon}
        {props.label}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={props.menuStyle}
      >
        {childrenWithProps}
      </Menu>
    </React.Fragment>
  );
};
DropdownIcon.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
  menuStyle: PropTypes.object,
  disabled: PropTypes.bool,
  label: PropTypes.any,
};

export {
  DropdownIcon,
  Dropdown,
  MenuItem as DropdownMenuItem,
};
